// Close cart drawer when Gokwik or dynamic checkout buttons are clicked
(function() {
  'use strict';

  function initCheckoutButtonHandler() {
    // Function to close cart drawer
    function closeCartDrawer() {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.close === 'function') {
        cartDrawer.close();
      }
    }

    // Use event delegation for dynamically added buttons
    document.addEventListener('click', function(e) {
      // Check if clicked element or its parent is a Gokwik or dynamic checkout button
      const target = e.target.closest('.gokwik-checkout-button, .dynamic-checkout-button, .shopify-payment-button__button, [class*="gokwik"]');
      
      if (target) {
        console.log('Checkout button clicked, closing cart drawer');
        closeCartDrawer();
      }
    }, true); // Use capture phase to catch it early

    // Also listen for Gokwik specific events if they exist
    document.addEventListener('gokwik:checkout:init', closeCartDrawer);
    document.addEventListener('gokwik:checkout:open', closeCartDrawer);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheckoutButtonHandler);
  } else {
    initCheckoutButtonHandler();
  }
})();
